<template lang="html">
  <div class="sub-main column">
		<div class="sub-page column">
			  <section class="take-place column activity-container container-background">
					<div class='header-table row'>
						<div class='title'>
							Cabinets
						</div>
						<div class="attached-item row">
							<div class="phantom-flex"></div>
							<!-- <div class="ctn-cta">
								<div class="btn btn-red" @click="showAddCabinet = true">
									<span class="icon-form-plus"></span> Ajouter un cabinet
								</div>
							</div> -->
						</div>
					</div>
					<Table :elements="cabinets" :clickable="false" @statuschange="updateStatus" />
					<baseModal :show="showAddCabinet" @close="showAddCabinet = false" :content="contentModal" />
  			</section>
		</div>
  </div>
</template>

<style lang="scss">
</style>

<script>
import store from '@/store'
import {mapGetters} from 'vuex'
import ModalAddCabinet from './modals/CabinetModal'
import baseModal from '@/common/components/baseModal'
import Table from './CabinetsTable'

export default {
	name: 'Cabinets',
	components: {
		Table,
		baseModal
	},
	data () {
		return {
			showAddCabinet: false,
			contentModal: ModalAddCabinet
		}
	},
	beforeRouteEnter (to, from, next) {
		store.commit('LOADER_IN')
    store.dispatch('getCabinets')
    // .then(() => new Promise((resolve, reject) => {
    //   resolve();
    // }))
    .then(() => {
      let getClientsPromises = store.getters.cabinets.map((office) => {
        return store.dispatch('getClientsByOfficeId', office.id);
      });
      let getAdvisorsPromises = store.getters.cabinets.map((office) => {
        return store.dispatch('getAdvisorsByOfficeId', office.id);
      });
      let getAdminPromises = store.getters.cabinets.map((office) => {
        return store.dispatch('getAdminByOfficeId', office.id);
      });
      return Promise.all([
        ...getClientsPromises,
        ...getAdvisorsPromises,
        ...getAdminPromises
      ])
    })
    .then(() => {
			next()
    })
    .catch(() => {
			next(false)
    })
    .finally(() => {
			store.commit('LOADER_OUT')
    })
	},
	methods: {
		updateStatus (e) {
			const {value, rowIndex} = e
			const cabinet = {...this.cabinets[rowIndex], available: !value}
			this.$store.dispatch('editCabinet', cabinet)
		}
	},
	computed: {
		...mapGetters({
			cabinets: "cabinets"
		})
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?84f89a1e